module.exports = __webpack_public_path__ + "img/404.09576b58.png";